import React from 'react'
import styles from './style.module.scss'
import { useMemo } from 'react'
import XColors from 'v2/styles/colors'

export interface XIconProps {
    icon: any
    tintColor?: string

    // EITHER
    size?: number | number[]
    // OR
    width?: number[] | string
    height?: number[] | string
}

const XIcon = (props: XIconProps) => {
    const { icon: IconComponent, tintColor = XColors.white, size, width, height } = props

    const resolvedTintColor = tintColor

    const resolvedSizeProps = useMemo(() => {
        if (size) {
            return { width: size, height: size }
        } else {
            return { width: 20, height: 20 }
        }
    }, [size, width, height])

    return (
        <IconComponent
            className={styles.xIcon}
            style={{
                color: resolvedTintColor,
                width: `${resolvedSizeProps.width}px`,
                height: `${resolvedSizeProps.height}px`,
            }}
        />
    )
}

export default XIcon
